(function () {
  /* Swipe progress bar for horizontal card rows on mobile */
  function bar(track) {
    if (!track || track.nextElementSibling && track.nextElementSibling.classList.contains('ws-swipehint')) return;
    var hint = document.createElement('p'); hint.className = 'ws-swipehint'; hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = '<i><b></b></i><span>Swipe</span>';
    track.parentNode.insertBefore(hint, track.nextSibling);
    var b = hint.querySelector('b');
    function upd() {
      var max = track.scrollWidth - track.clientWidth; if (max <= 0) { hint.style.display = 'none'; return; }
      var w = Math.max(0.15, track.clientWidth / track.scrollWidth);
      b.style.width = (w * 100) + '%';
      b.style.transform = 'translateX(' + ((track.scrollLeft / max) * (1 / w - 1) * 100) + '%)';
    }
    track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }
  document.querySelectorAll('.ws-ingt, .ws-cmp').forEach(bar);
})();
